import React from 'react'

function AgriculturalLicense() {
  return (
    <>
      <head style={{all:'initial'}}>
                <title>شركات تأسيس أعمال في جدة</title>
                <meta name="description" content="شركات تأسيس أعمال في جدة"/>
                <meta name="keywords" content="شركات تأسيس أعمال في جدة" />
            </head>
      <div style={{padding:'50px',fontSize:'10px'}}>
          <h1>تقدم هذه الخدمة للمنشآت التي ترغب بممارسة
              <br />
              الأنشطة الزراعية</h1>
      </div>
    </>
  )
}

export default AgriculturalLicense